import React from 'react';
import {
  makeStyles,
  mergeClasses,
  shorthands,
} from '@fluentui/react-components';
import { ToggleButtons } from '@bingads-webui-campaign-react/ads-studio-shared-components';

const useStyles = makeStyles({
  toggleButton: {
    minWidth: 'unset',
    fontWeight: 'unset',
  },
  toggleButtons: {
    display: 'flex',
    columnGap: '8px',
  },
  selectedButton: {
    minWidth: 'unset',
    backgroundColor: '#EBF3FC',
    ...shorthands.border('1px', 'solid', '#B4D6FA'),
    color: '#115EA3',
  },
});

export const AssetTypeToggleButtonsFilter = (props) => {
  const {
    className,
    options,
    optionsState,
    toggleSelectedOption,
  } = props;

  const classes = useStyles();

  return (
    <div className={className}>
      <div className={mergeClasses('asset-type-filter', classes.toggleButtons)}>
        <ToggleButtons
          options={options}
          classes={classes}
          optionsState={optionsState}
          toggleSelectedOption={toggleSelectedOption}
        />
      </div>
    </div>
  );
};
